import {PlainDetails} from "../../../types/admin";
import {ADMIN_LANG} from "../../../settings";
import {Eye, PlusCircleFill, XCircle} from "react-bootstrap-icons";
import React from "react";

type Props = {
    item: PlainDetails | null
    handleAddNew: (formType?: 'start' | 'end') => void
    handleViewItem: (item: PlainDetails) => void
    handleRemoveSelection: (formType?: 'start' | 'end') => void
    formType?: 'start' | 'end'
}

export const AsyncOptions = ({item, handleAddNew, handleViewItem, handleRemoveSelection, formType}: Props) => {
    return (
        <>
            {!item ? (
                <PlusCircleFill onClick={() => handleAddNew(formType)}
                                title={ADMIN_LANG.add}
                                size='1.8rem'
                                className='text-success ms-2 cursor-pointer'/>
            ) : (
                <>
                    <Eye onClick={() => handleViewItem(item)}
                         title={ADMIN_LANG.preview}
                         size='1.8rem'
                         className='text-secondary ms-2 cursor-pointer'/>
                    <XCircle onClick={() => handleRemoveSelection(formType)}
                             title={ADMIN_LANG.remove_selection}
                             size='1.8rem'
                             className='text-danger ms-2 cursor-pointer'/>
                </>
            )}
        </>
    )
}